/**
 * Nombres y etiquetas de las wallets.
 * Wallet 1 = tiempo aire (recargas/activaciones).
 * Wallet 2 = comisiones.
 * Wallet 4 = saldo de SERVICIOS (pago de recibos). Lo carga el A a sus B, sin bono.
 * Wallet 5 = saldo RETENIDO (abonos SPEI por debajo del mínimo). No es gastable:
 *            espera a que un ADMIN lo libere a Tiempo Aire o lo devuelva.
 *
 * 3 y 4 los reserva el mapa de bloques de CLABE del backend (venta de recargas y pago de
 * servicios); el 4 ya se usa para servicios, el 3 sigue libre. Por eso el retenido es el 5.
 */
export const WALLET_NAMES = {
  wallet1: "Tiempo Aire",
  wallet2: "Comisiones",
  wallet4: "Saldo de servicios",
  wallet5: "Saldo retenido",
} as const

export const WALLET_1_NAME = WALLET_NAMES.wallet1
export const WALLET_2_NAME = WALLET_NAMES.wallet2
export const WALLET_RETENIDO_NAME = WALLET_NAMES.wallet5

export type WalletKey = keyof typeof WALLET_NAMES

/** Etiqueta para mostrar por número de wallet */
export function getWalletName(numeroWallet: 1 | 2 | 4 | 5): string {
  if (numeroWallet === 5) return WALLET_RETENIDO_NAME
  if (numeroWallet === 4) return WALLET_NAMES.wallet4
  return numeroWallet === 1 ? WALLET_1_NAME : WALLET_2_NAME
}

/** Descripción corta de cada wallet */
export const WALLET_DESCRIPTIONS = {
  wallet1: "Saldo para recargas y activaciones",
  wallet2: "Comisiones generadas",
  wallet4: "Solo para pago de servicios. Lo carga tu distribuidor A.",
  wallet5: "Transferencias por debajo del mínimo. No se puede usar hasta liberarse.",
} as const
